import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const CTASection = () => {
  return (
    <section className="py-24 md:py-32">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative text-center max-w-3xl mx-auto rounded-3xl overflow-hidden p-12 md:p-20"
          style={{
            background: "radial-gradient(ellipse 80% 60% at 50% 50%, hsl(174 65% 45% / 0.1) 0%, hsl(220 28% 10% / 0.9) 70%)",
            border: "1px solid hsl(174 65% 45% / 0.25)",
            boxShadow: "0 0 80px hsl(174 65% 45% / 0.1), inset 0 0 60px hsl(174 65% 45% / 0.04)"
          }}
        >
          {/* Decorative corner glows */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent" aria-hidden="true" />
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-64 h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" aria-hidden="true" />

          <p className="text-xs font-medium text-primary/80 uppercase tracking-widest mb-4">Get Started</p>
          <h2 className="text-3xl sm:text-5xl font-display font-bold mb-6">
            Ready to find your match?
          </h2>
          <p className="text-muted-foreground text-lg mb-10 max-w-xl mx-auto">
            Join hundreds of founders and investors already using AdV3nture to make the connections that matter.
          </p>
          <Button
            asChild
            size="lg"
            className="text-base px-10 py-6 gap-2 bg-primary text-primary-foreground hover:bg-primary/90"
            style={{ boxShadow: "0 0 40px hsl(174 65% 45% / 0.4)" }}
          >
            <a href="https://app.adv3nture.io" target="_blank" rel="noopener noreferrer">
              Get Early Access <ArrowRight className="w-4 h-4" />
            </a>
          </Button>
          <p className="text-xs text-muted-foreground mt-5">Free to join · No credit card required</p>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
